import { defineFcm } from '../shared/factory';

export const FCM_MEMBERSHIP_BOTTOM_BANNER_ENABLED_FOR = defineFcm('membership_bottom_banner_enabled_for')
	.asBoolean()
	.withDefault(false)
	.toConfig();
